export default __webpack_public_path__ + "static/parigi-plus-lite-1-6393b850754fc31cabaf2f3dad28492e.jpg";